export const textFieldIsEmpty = (textFieldValue: string | number): boolean => {
  const stringifiedValue = textFieldValue.toString();
  return stringifiedValue.trim() === '';
};
